import { IonBackButton } from '@ionic/react';
import styled from 'styled-components';

export const StyledBackButton: any = styled(IonBackButton)`
  --color: var(--allie-color-primary-60);
  --padding-start: 0;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --border-radius: 0;
  --icon-font-size: 36px;
`;
